import { z } from 'zod';

export const reconcileSocialPostsV1RequestSchema = z.object({
  socialVideoId: z.number(),
});

export type IReconcileSocialPostsV1Request = z.infer<typeof reconcileSocialPostsV1RequestSchema>;
